
/**
 * Definition of the global configuration initial used by the application
 *
 */
export const initialAppData = {

  currentStep: 'start', // Initial step
  currentJourney: '_default', // Initial default route
  direction: 'left', // Initial value

  document: {
    title: document.title // Initial value
  },

  /**
   * USER JOURNEYS
   * The possible user journeys, sperated by the journey and inside of them each possible step
   */
  journeys: {

    /**
     * USER JOURNEY: Default / Initial
     */
    _default: {
      start: {
        componentName: 'StepInitial'
      },

      questionA: {
        componentName: 'StepKategorie',
        finished: false, // Initial value
        answer: false // Initial value
      }
    },

    /**
     * USER JOURNEY: Schüler Gruppe
     */
    schuelerGruppe: {
      questionB: {
        componentName: 'StepBewerber',
        finished: false, // Initial value
        answer: false // Initial value
      },

      questionC: {
        componentName: 'StepHinweise',
        finished: false, // Initial value
        answer: false // Initial value
      },

      questionD: {
        componentName: 'StepHinweiseRecht',
        finished: false // Initial value
      },

      questionE: {
        componentName: 'StepHinweiseSchutzanmeldung',
        finished: false // Initial value
      },

      result: {
        componentName: 'StepErgebnis',
        finished: false // Initial value
      }
    },

    /**
     * USER JOURNEY: Privat Erfinder mit Patent
     */
    privatePerson: {
      questionB: {
        componentName: 'StepBewerber',
        finished: false, // Initial value
        answer: false // Initial value
      },

      questionC: {
        componentName: 'StepSchutzrecht',
        finished: false, // Initial value
        answer: false // Initial value
      },

      questionD: {
        componentName: 'StepVerwertung',
        finished: false // Initial value
      },

      result: {
        componentName: 'StepErgebnis',
        finished: false // Initial value
      }
    },

    /**
     * USER JOURNEY: Schüler/Gruppe mit Patent
     */
    // schuelerGruppePatent: {
    //   questionB: {
    //     componentName: 'StepBewerber',
    //     finished: false, // Initial value
    //     answer: false // Initial value
    //   },

    //   questionC: {
    //     componentName: 'StepHinweise',
    //     finished: false, // Initial value
    //     answer: false // Initial value
    //   },

    //   result: {
    //     componentName: 'StepErgebnis',
    //     answer: true,
    //     finished: true
    //   }
    // }

  } // End of the Journeys

};
